import { useFlags } from "flagsmith/react";
import { TagsPopoverProps } from "src/components/Tags";
import { RemoteData } from "src/types/remoteData";
import { FormId } from "../forms/types";
import { useFormTags as useFormTagsFS } from "./useFormTagsFS";
import { useFormTags as useFormTagsLegacy } from "./useFormTagsLegacy";

type Props = {
  enrollmentPeriodId: uuid;
};

type ReturnType = {
  tagsProps: TagsPopoverProps;
  setSelectedRows: (selectedRows: RemoteData<unknown, FormId[]>) => void;
  isDirty: boolean;
  resetFormTags: () => void;
};

export function useFormTags({ enrollmentPeriodId }: Props): ReturnType {
  const flags = useFlags(["tags-form-service"]);
  const isFormServiceEnabled = flags["tags-form-service"].enabled;

  // TODO: remove legacy when the new formservice tags are widely used
  const legacy = useFormTagsLegacy(
    { enrollmentPeriodId },
    isFormServiceEnabled
  );

  // TODO: remove skip when the new formservice tags are widely used
  const fs = useFormTagsFS({ enrollmentPeriodId }, !isFormServiceEnabled);

  return isFormServiceEnabled ? fs : legacy;
}
